import { ChangeDetectionStrategy, Component, inject, input } from '@angular/core';
import { MatIconModule } from '@angular/material/icon';
import { RouterLink } from '@angular/router';
import { StatCard } from '../../models';
import { NxIconService } from '../../../../core/services/icon.service';

@Component({
  selector: 'app-stats-cards',
  imports: [MatIconModule, RouterLink],
  template: `
    <div class="grid grid-cols-3 gap-2">
      @for (card of cards(); track card.label) {
        <a [routerLink]="card.route"
          class="flex flex-col items-center gap-1 rounded-pmdf-card bg-pmdf-surface shadow-pmdf-card py-3 px-1 transition-colors hover:bg-pmdf-border-subtle">
          @if (card.svgIcon) {
            <mat-icon [svgIcon]="card.svgIcon" class="icon-2xl" [class]="card.colorClass ?? 'text-pmdf-primary'"></mat-icon>
          } @else {
            <mat-icon class="icon-2xl" [style.color]="card.color">{{ card.icon }}</mat-icon>
          }
          <span class="text-lg font-bold text-pmdf-muted-70 leading-none">{{ card.value }}</span>
          <span class="text-sm text-pmdf-muted-55 text-center leading-tight">{{ card.label }}</span>
        </a>
      }
    </div>
  `,
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class StatsCards {
  private readonly _iconService = inject(NxIconService);
  cards = input.required<StatCard[]>();
}
